import { useMemo, useState } from 'react';

import { DEFAULT_FIRST_PAGE, DEFAULT_PAGE_SIZE } from 'v2/constants';
import { IPagination } from 'v2/types';

export interface UsePaginationOptions {
  defaultFirstPage?: number;
  defaultPageSize?: number;
}

export function usePagination(pagination?: UsePaginationOptions): IPagination {
  const [page, setPage] = useState(pagination?.defaultFirstPage ?? DEFAULT_FIRST_PAGE);
  const [pageSize, setPageSize] = useState(pagination?.defaultPageSize ?? DEFAULT_PAGE_SIZE);

  return useMemo(
    () => ({
      page,
      pageSize,
      onPageChange: setPage,
      onPageSizeChange: setPageSize,
    }),
    [page, pageSize]
  );
}
